import axios from 'axios';
import Configs from '../config';
import CONSTANTS from '../constants/sessionStorageKeys';

export const createHeaders = (xAuthToken) => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  };
  if (xAuthToken) headers[CONSTANTS.X_AUTH_TOKEN] = xAuthToken;
  const traceId = sessionStorage.getItem(CONSTANTS.TRACEPARENT);
  if (traceId) headers[CONSTANTS.TRACEPARENT] = traceId;
  return headers;
};

export const getRequest = async (requestUrl, isAuth = true) => {
  const headers = createHeaders(isAuth);
  return axios({
    method: 'GET',
    headers,
    url: `${Configs.API_URL}${requestUrl}`,
  }).then((response) => response)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return error.request;
      } else {
        return error.message;
      }
    });
};

export const postRequest = async (requestUrl, data, xAuthToken = null) => {
  const headers = createHeaders(xAuthToken);
  return axios({
    method: 'POST',
    headers,
    url: `${Configs.API_URL}${requestUrl}`,
    data,
  }).then(response => response)
    .catch(error => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return error.request;
      } else {
        return error.message;
      }
    });
};
